export class CandidateModel {
  constructor (jsonObj) {
    this.id = Number(jsonObj.id) || null
    this.email = jsonObj.email || null
    this.firstName = jsonObj.firstName || null
    this.lastName = jsonObj.lastName || null
    this.phoneNumber = jsonObj.phoneNumber || null
  }
}



// WEBPACK FOOTER //
// ./src/model/candidate.js